








































































/* General */

/* Mixins */
import SearchableDropdownMixin from '@/mixins/searchable-dropdown.mixin'

/* Components */

/* Helpers */
import TextAssistant from '@/helpers/text-assistant'

/* Data types */
import { IPersonWithEmail } from '@/api/types/response.types'
import { EEntities } from '@/types'

/* API */

export default SearchableDropdownMixin.extend({
  name: 'WatchersPicker',

  props: {
    options: {
      type: Array as () => IPersonWithEmail[],
      default: () => [] as IPersonWithEmail[],
    },
    currentUserId: {
      type: Number,
      default: null,
    },
    type: {
      type: String as () => EEntities,
      default: EEntities.MAILBOXES,
    },
    hideInstructions: {
      type: Boolean,
      default: false,
    },
    fromDrawer: {
      type: Boolean,
      default: false,
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      showWatchersList: false,

      /* SearchableDropdownMixin configuration */
      allowMultipleSelections: true,
    }
  },

  computed: {
    currentUser(): IPersonWithEmail {
      return this.options.find(p => p.id === this.currentUserId)
    },
    totalOptionsCount(): number {
      return this.options.length
    },
    filteredOptions(): IPersonWithEmail[] {
      const result = this.options.filter(p => p.id !== this.currentUserId)

      if (this.filterQuery.length === 0) {
        return result
      }

      return result.filter(person => {
        return person.name
          .toLowerCase()
          .includes(this.filterQuery.toLowerCase())
      })
    },
    hasWatchers(): boolean {
      return this.selectedWatchers.length > 0
    },
    selectedWatchers(): IPersonWithEmail[] {
      return this.options.filter(o => this.internalSelectedIDs.includes(o.id))
    },
    isCurrentUserSelected(): boolean {
      return this.isSelected(this.currentUserId)
    },
    getTypeString(): string {
      return TextAssistant.itemSingularName(this.type).toLowerCase()
    },
    instructions(): string {
      if (!this.hasWatchers) {
        return `Add watchers to this ${this.getTypeString}...`
      }

      if (this.selectedWatchers.length === 1) {
        if (this.isCurrentUserSelected) {
          return `You are watching this ${this.getTypeString}`
        }

        return `${this.selectedWatchers[0].name} is watching this ${
          this.getTypeString
        }`
      }

      return `${this.selectedWatchers.length} people are watching this ${
        this.getTypeString
      }`
    },
    maxNumberAvatars(): number {
      return this.$screen.isMobile(this.$mq) || this.fromDrawer ? 6 : 10
    },
  },
})
